import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { ISendMessageState, SendMessageState } from './states.store';
import { PropertyServices, DemandServices, PersonServices } from '../../../services';
import { ReportServices } from '../../../services/report.services';

/** SEND MESSAGE CHILD component */
import sendMessageActions from './actions.store';
import sendMessageGetters from './getters.store';
import sendMessageMutations from './mutations.store';

/** define module */
export class SendMessageModule<RootState> implements Module<ISendMessageState, RootState>{
  namespaced: boolean;
  state: ISendMessageState;
  getters: GetterTree<ISendMessageState, RootState>;
  actions: ActionTree<ISendMessageState, RootState>;
  mutations: MutationTree<ISendMessageState>;
  /**
   *
   */
  constructor() {
    this.namespaced = true;
    this.state = new SendMessageState({ service: new ReportServices, propertyService: new PropertyServices, demandService: new DemandServices, personService: new PersonServices});

    this.mutations = {
      ...sendMessageMutations,
    };

    this.actions = {
      ...sendMessageActions,
    };

    this.getters = {
      ...sendMessageGetters,
    };
  }
}
